import { FormGroup } from '@angular/forms';

export const CANCELLATION_TRANSACTION_TYPE = 'CAN';

/** Fields the broker may still edit on a cancellation, even though the client is already selected. */
export const CANCELLATION_EDITABLE_FIELDS = [
  'ClientEmailAddressTxt',
  'ClientPhoneNumberNum',
  'ClientAddressSearchTxt',
  'ClientStreetAddressTxt',
  'ClientStreetDirectionCd',
  'ClientAddressUnitDesignationCd',
  'ClientAddressUnitNum',
  'ClientAddressPOBoxTxt',
  'ClientAddressRouteTypeCd',
  'ClientAddressRouteNum',
  'ClientAddressStationNameCd',
  'ClientAddressStationNum',
  'ClientAddressCountryCd',
  'ClientAddressProvinceCd',
  'ClientAddressMunicipalityTxt',
  'ClientAddressPostalTxt'
];

/** Auto configs use ClientContactInformation; HAB configs use ClientPrimaryInsuredContactInformation. */
export function getContactInfoForm(clientForm: FormGroup, formName: string): FormGroup | null {
  if (!clientForm) return null;
  const form = (clientForm.controls[formName]
    ?? clientForm.controls['ClientContactInformation']
    ?? clientForm.controls['ClientPrimaryInsuredContactInformation']) as FormGroup;
  return form || null;
}
